import React from 'react';
import {convertDurationsToMonths} from '../utils/durationUtils';
import RangeSlider from './RangeSlider';
import {formatCurrency} from '../utils/currencyUtils';
import './LoanForm.css';

const LoanForm = ({
                      productData,
                      amountSelected,
                      durationSelected,
                      currency,
                      installmentDetails,
                      handleAmountChange,
                      handleDurationChange,
                      onSubmit,
                      onSecciRequest,
                      getValidDurations,
                      labels,
                      isLoading,
                      onlyApplyButton,
                      applyButtonId,
                      hideDuration,
                      creditAccountLabel,
                      fullDisclosureMode,
                      amountTouched,
                      durationTouched,
                  }) => {
    if (!productData) return null;

    const durations = isLoading
        ? [1, 3, 6, 9, 12]
        : convertDurationsToMonths(getValidDurations());

    if (onlyApplyButton) {
        return (
            <form onSubmit={onSubmit} className={`loan-form ${isLoading ? 'loading-state' : ''} only-apply-button`}>
                <div className="button-container">
                    <button
                        type="submit"
                        className={`apply-button ${isLoading ? 'disabled' : ''}`}
                        id={applyButtonId}
                        disabled={isLoading}
                    >
                        {labels.submitLabel || "Apply Now"}
                    </button>
                </div>
            </form>
        );
    }

    const decimals = labels.numDecimalMonthly ?? 0;
    const hasSelection = fullDisclosureMode ? (amountTouched && durationTouched) : true;
    const monthly = installmentDetails.installmentAmount || 0;
    const totalFromApi = installmentDetails.totalAmount;
    const totalAmount = hasSelection
        ? (totalFromApi != null ? totalFromApi : monthly * durationSelected)
        : 0;
    const formattedMonthly = hasSelection
        ? formatCurrency(monthly, decimals)
        : formatCurrency(0, decimals);
    const formattedTotal = hasSelection
        ? formatCurrency(totalAmount, decimals)
        : formatCurrency(0, decimals);
    const formattedAmountValue = fullDisclosureMode && !amountTouched
        ? formatCurrency(0, 0, currency)
        : formatCurrency(installmentDetails.principal, 0, currency);
    const formattedDurationValue = fullDisclosureMode && !durationTouched
        ? `0 ${labels.monthsLabel || ''}`
        : `${durationSelected} ${labels.monthsLabel || ''}`;

    return (
        <form onSubmit={onSubmit} className={`loan-form ${isLoading ? 'loading-state' : ''} ${fullDisclosureMode ? 'full-disclosure-mode' : ''}`}>
            <div className="slider-container">
                {labels.loanAmountLabel && (
                    <div className="label-container center">
                        <h2>{labels.loanAmountLabel}</h2>
                    </div>
                )}
                <div className="label-container">
                    {currency === "£" ? (
                        <p className="priceclass">
                            <span>{currency}</span>
                            {formattedAmountValue}
                            <span className='label-credit-account'>{creditAccountLabel}</span>
                        </p>
                    ) : (
                        <p className="priceclass">
                            {formattedAmountValue}
                            <span>{currency}</span>
                            <span className='label-credit-account'>{creditAccountLabel}</span>
                        </p>
                    )}
                </div>
                <div className="label-container monthly-row">
                    <span className="label-text">
                        {labels.monthlyLabel || "Loan Duration (Months)"}
                    </span>

                                    <span className="value-text">
                        {currency === "£" && <span>{currency}</span>}
                                        {formattedMonthly}
                                        {currency !== "£" && <span> {currency}</span>}
                    </span>
                </div>

                <div className="sliders">
                    <RangeSlider
                        values={productData.amountRange}
                        value={amountSelected}
                        onChange={handleAmountChange}
                        hideFromTo={true}
                        hideMinMax={true}
                        disabled={isLoading}
                    />

                    {!hideDuration && (
                        <>
                            <div className="label-container">
            <span className="label-text">
                {labels.durationLabel || "Loan Duration (Months)"}
            </span>
                                <span className="value-text">
                {formattedDurationValue}
            </span>
                            </div>

                            <RangeSlider
                                values={durations}
                                value={durationSelected}
                                onChange={handleDurationChange}
                                hideFromTo={true}
                                hideMinMax={true}
                                disabled={isLoading}
                            />
                        </>
                    )}

                </div>

                {fullDisclosureMode && (
                    <div className="label-container total-amount-row">
                        <span className="label-text">
                            {labels.totalAmountLabel || 'Total amount payable'}
                        </span>
                        <span className="value-text">
                            {currency === "£" && <span>{currency}</span>}
                            {formattedTotal}
                            {currency !== "£" && <span> {currency}</span>}
                        </span>
                    </div>
                )}

                {labels.infoLinkLabel && (
                    <div className="label-container">
                        <a
                            href="#"
                            className={`secci-button ${isLoading ? 'disabled' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                if (!isLoading) onSecciRequest();
                            }}
                        >
                            {labels.infoLinkLabel || "View SECCI Document"}
                        </a>
                    </div>
                )}
            </div>

            <div className="button-container">

                <button
                    type="submit"
                    className={`apply-button ${isLoading ? 'disabled' : ''}`}
                    id={applyButtonId}
                    disabled={isLoading || (fullDisclosureMode && !hasSelection)}
                >
                    {labels.submitLabel || "Apply Now"}
                </button>
            </div>
        </form>
    );
};

export default LoanForm;
